"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _field = _interopRequireDefault(require("./field"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var DateField =
/*#__PURE__*/
function (_Field) {
  (0, _inherits2.default)(DateField, _Field);

  function DateField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DateField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DateField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'DateField');
    return _this;
  }

  (0, _createClass2.default)(DateField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(DateField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'now',
            component: 'BooleanField'
          }, {
            name: 'includeTime',
            component: 'BooleanField',
            label: 'Include Time',
            docLevel: 'basic'
          }, {
            name: 'minDate',
            component: 'DateField',
            label: 'Min Date',
            docLevel: 'basic'
          }, {
            name: 'maxDate',
            component: 'DateField',
            label: 'Max Date',
            docLevel: 'basic'
          }]
        }
      });
    }
  }, {
    key: "now",
    value: function now() {
      this.set({
        value: new Date()
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      var clonedProps = Object.assign({}, props);

      if (props.now !== undefined) {
        this.now(); // Clear now so we can trigger it back to back. TODO: is there an automatic way of handling
        // this via some property like ephemeral:true?

        delete clonedProps.now;
      } // Convert Date? We store dates in epoch time so that they are compatiable across all stores.
      // Epoch time is also smaller than the ISO string and can therefore minimize the storage needed.


      if (clonedProps.value !== undefined && typeof clonedProps.value !== 'number') {
        clonedProps.value = this.constructor.toEpochTime(props.value);
      }

      (0, _get2.default)((0, _getPrototypeOf3.default)(DateField.prototype), "set", this).call(this, clonedProps);
    } // For mocking

  }, {
    key: "_toLocaleString",
    value: function _toLocaleString(date) {
      return this.get('includeTime') ? date.toLocaleString() : date.toLocaleDateString();
    }
  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      return this.isBlank() ? null : this._toLocaleString(new Date(this.getValue()));
    }
  }, {
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf3.default)(DateField.prototype), "validate", this).call(this);

      if (!this.isBlank()) {
        var value = this.getValue();
        var date = new Date(value);
        var minDate = this.get('minDate') ? new Date(this.get('minDate')) : null;
        var maxDate = this.get('maxDate') ? new Date(this.get('maxDate')) : null;

        if (!(0, _isValid.default)(date)) {
          this.setErr("invalid");
        } else if (minDate !== null && date.getTime() < minDate.getTime()) {
          this.setErr("must be after ".concat(this._toLocaleString(minDate)));
        } else if (maxDate !== null && date.getTime() > maxDate.getTime()) {
          this.setErr("must be before ".concat(this._toLocaleString(maxDate)));
        }
      }
    }
  }], [{
    key: "toEpochTime",
    value: function toEpochTime(value) {
      if (value instanceof Date) {
        return value.getTime();
      } else if (typeof value === 'string') {
        return new Date(value).getTime();
      } else {
        // We assume it is already epoch time
        return value;
      }
    }
  }]);
  return DateField;
}(_field.default);

exports.default = DateField;